import { render, staticRenderFns } from "./EmptyDataDialog.vue?vue&type=template&id=20e00d0b"
import script from "./EmptyDataDialog.vue?vue&type=script&lang=js"
export * from "./EmptyDataDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports